module.exports = __webpack_public_path__ + "img/jnv-logo.1797d2f4.svg";